<template>
	<div class="uupay-container">

    <UUPayBannerProduct banner-img="pos_banner">
      <template v-slot:title>
        <div><img src="@/assets/uupay/images/logo_product.png" class="img-fluid"></div> 
        <div class="banner-title-uu">收款機</div>
      </template>
      <template v-slot:subtitle>
        用科技賦能每一筆交易
      </template>
      <template v-slot:info>
        線下門市專用UUPAY收款機，無縫連結UUPAY APP，隨時隨地管理你的機器
      </template>
    </UUPayBannerProduct>

    <product-feature :list="productFeatures" />


    <func-feature :title="funcTitle" :list="funcFeatures"/>

    <safe-account :list="safeList" />

    <UUPayBannerContact :info="['我準備好了！你呢？']" />
  </div>
</template>
<script>
import UUPayBannerContact from "@/components/uupayBannerContact";
import ProductFeature from "@/components/ProductFeature";
import UUPayBannerProduct from "@/components/uupayBannerProduct";
import FuncFeature from "@/components/FuncFeature";
import SafeAccount from "@/components/SafeAccount";

export default {
  name: 'UUPayPos',
  components: {
    UUPayBannerContact,
    ProductFeature,
    UUPayBannerProduct,
    FuncFeature,
    SafeAccount
  },
  data() {
    return {
      productFeatures: [
        {id: 0, imgSrc: 'pos_app', desc: 'APP支持'},
        {id: 1, imgSrc: 'pos_wifi', desc: 'WIFI連接'},
        {id: 2, imgSrc: 'pos_credit_card', desc: '信用卡收款'},
        {id: 3, imgSrc: 'pos_database', desc: '多幣種結算'},
        {id: 3, imgSrc: 'pos_shopping_bag', desc: '流動便捷支付'},
        {id: 3, imgSrc: 'pos_gift', desc: '更多功能'},
      ],
      funcTitle: {
        highLight: '最智能',
        desc: '的收款機',
      },
      funcFeatures: [
        {
          id: 0, imgSrc: 'pos_product_income', title: '信用卡收款服務', imgStyle: {},
          info: [
            {id: 0, desc: '支持實體卡快捷支付功能'},
            {id: 1, desc: '多幣種接受'},
            {id: 2, desc: '交易明細易查詢'},
          ]
        },
        {
          id: 1, imgSrc: 'pos_product_qrcode', title: '二維碼收款服務', imgStyle: {'margin-left': '2rem'},
          info: [
            {id: 0, desc: '通過掃描電子錢包實現快速收款'},
            {id: 1, desc: '緊密貼合商業帳戶高速增長的應用場景'},
            {id: 2, desc: '支持雙向掃碼'},
          ]
        },
        {
          id: 3, imgSrc: 'pos_multiple_device', title: '多設備連接', imgStyle: {'margin-left': '2rem'},
          info: [
            {id: 0, desc: '掃描即配對'},
            {id: 1, desc: '支持數十種通道收費'},
            {id: 2, desc: '支持遠程斷聯'},
          ]
        },
      ],
      safeList: [
        {id: 0, imgSrc: 'app_pci_level', title: 'PCI Level 1', style: {height: '60px', 'margin': '1rem 0 0.3rem 0'},
         desc: '使用端對端加密技術把交易的所有數據加密傳輸，確保信用卡資料保密和交易安全。'},
        {id: 0, imgSrc: 'app_visa', title: 'Visa PayWave', style: {},
         desc: 'Visa PayWave 支援使用 Visa 卡或裝置透過射頻或 NFC 技術進行非接觸式支付，減少信用卡被盗機會。'},
        {id: 0, imgSrc: 'app_master', title: 'Mastercard Paypass', style: {},
         desc: 'Mastercard Paypass 透過 NFC 技術，只需輕觸銀行卡、手機或其他支付設備即可實現快速、簡單的支付。'},
        {id: 0, imgSrc: 'app_unionpay', title: 'UnionPay', style: {},
         desc: '獲銀聯認證之支付平台，可以受理銀聯IC卡進行交易。'},
        {id: 0, imgSrc: 'app_swift', title: 'SVF', style: {},
         desc: '獲香港儲值支付工具牌照，合法營運線上支付、銷售點流動支付、P2P轉帳、實體卡四個方面'},
        {id: 0, imgSrc: 'app_mso', title: 'MSO', style: {},
         desc: '獲得權威批准-代表在港貨幣及外匯市場上獲得了“通行證”，每一筆交易都是接受香港政府監督，100%合規保障。'},
      ]
    }
  },

}
</script>
<style scoped>


.modules-section {
  margin: 100px 0;
}

.modules-section-container {
  max-width: 1440;
}
.modules-section .content {
  background-color: #f8f8f8;
  border-radius: 6px;
}
.modules-section .pos-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 4.5rem 0 2rem 0;
}
.modules-section .title {
  font-size: 30px;
  line-height: 100%;
  color: #21042e;
  margin-bottom: 1rem;
  font-weight: 600;
}
.modules-section .subtitle {
  font-size: 18px;
  line-height: 100%;
  color: #bc68a4;
}
.modules-section .pos-img {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
}
.modules-section .pos-img-bg {
  background-image: url('/static/pos_bg.png');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
  width: 186px;
  height: 320px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.modules-section .content-row {
  margin: 40px 0;
}

.why-us-section {
  background-color: #f8f8f8;
  padding: 121px 0;
}
.why-us-section .container {
  max-width: 1440px;
}
.why-us-section .info {
  width: 500px;
  background-color: #fff;
  border-radius: 6px;
  padding: 3rem;
}
.why-us-section .info .question {
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  color: #9a307a;
  margin-bottom: 2.3rem;
}
.why-us-section .info .answer-title {
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  color: #21042e;
  margin-bottom: 1rem;
}
.why-us-section .info .answer-detail {
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  color: #4d4d4d;
}
.why-us-section .info .answer-icon {
  margin: 0.3rem 0.6rem 0 0;

}
</style>


// WEBPACK FOOTER //
// src/views/uupayPos.vue